module.exports = __webpack_public_path__ + "assets/img/peo.b8210259.png";